"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MARKING_TYPE", {
  enumerable: true,
  get: function get() {
    return _Label.MARKING_TYPE;
  }
});
exports.Selectable = void 0;
var _react = _interopRequireDefault(require("react"));
var _Label = require("b2b-components/theme/components/Form/Label");
var _classnames = _interopRequireDefault(require("classnames"));
var _Error = require("../../common/Error");
var _Info = require("../../common/Info");
var Selectable = function Selectable(_ref) {
  var className = _ref.className,
    children = _ref.children,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? null : _ref$error,
    _ref$info = _ref.info,
    info = _ref$info === void 0 ? null : _ref$info,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$markingType = _ref.markingType,
    markingType = _ref$markingType === void 0 ? _Label.MARKING_TYPE.none : _ref$markingType,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? {
      optional: '(optional)',
      required: '*'
    } : _ref$text;
  var Label = Selectable.Label,
    Error = Selectable.Error,
    Info = Selectable.Info;
  var rootClassName = (0, _classnames["default"])('cds-Form-Selectable', className);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label && /*#__PURE__*/_react["default"].createElement(Label, {
    markingType: markingType,
    text: text
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, children), error && /*#__PURE__*/_react["default"].createElement(Error, null, error), info && /*#__PURE__*/_react["default"].createElement(Info, null, info));
};
exports.Selectable = Selectable;
Selectable.Label = _Label.Label;
Selectable.Error = _Error.Error;
Selectable.Info = _Info.Info;
Selectable.config = {
  markingType: _Label.MARKING_TYPE
};